// Utils
import { tget } from '@tekion/tekion-base/utils/general';
import _get from 'lodash/get';
import { EMPTY_OBJECT } from '@tekion/tekion-base/app.constants';
export var getUserLabel = function getUserLabel(user) {
  var displayName = tget(user, 'displayName');
  var fName = tget(user, 'fname');
  var name = displayName || fName;
  var displayNumber = tget(user, 'employeeDisplayNumber');
  if (!displayNumber) {
    return displayName || fName;
  }
  if (!name) {
    return displayNumber;
  }
  return "".concat(displayNumber, " - ").concat(displayName);
};
var getUserOptionId = function getUserOptionId() {
  var option = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_OBJECT;
  return _get(option, 'userID') || _get(option, 'id');
};
var getOptionData = function getOptionData() {
  var option = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_OBJECT;
  return option;
};
var USER_OPTION_CONFIG = {
  getOptionLabel: getUserLabel,
  getOptionValue: getUserOptionId,
  getOptionData: getOptionData
};
export default USER_OPTION_CONFIG;